import React, { FC } from 'react'
import { IonFooter } from '@ionic/react'
import './index.scss'

interface IProps {
  className?: string;
}

const MktFooter: FC<IProps> = (props) => {
  const { className } = props
  return (
    <IonFooter>
      <div className={`mkt-footer ${className || ''}`}>
        {props.children}
      </div>
    </IonFooter>
  )
}

export default MktFooter
